<template>
  <jr-button class="send-btn" type="primary" @click="confirm" :disabled="disabled" :size="size">
    <span class="largest-btn-text"> 回答 </span>
  </jr-button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { ElForm } from 'element-plus'

import JrButton from '@/components/jr-parts/JrButton.vue'

import { MESSAGE_TYPE_CONFIRM, addMessageQueue } from '@/plugins/messageQueue'
import { ApplicantUpdateRequest } from '@/requests/scheduleAnswer'
import Message from '@/services/message'
import { ScheduleAnswerApplicantSend } from '@/api'

/**
 * 協議者日程回答送信ボタン
 */
export default defineComponent({
  name: 'ApplicantScheduleAnswerSend',
  emits: ['update:isSent'],
  components: {
    JrButton,
  },
  props: {
    // メッセージ内容
    scheduleAnswer: {
      type: Object as PropType<ScheduleAnswerApplicantSend>,
      required: true,
    },
    scheduleInquiryId: {
      type: Number,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props, context) {
    /**
     * メッセージ送信
     */
    const send = async () => {
      // メッセージ送信
      const request = new ApplicantUpdateRequest(props.scheduleInquiryId, props.scheduleAnswer)
      await request.exec()
      if (request.success) {
        context.emit('update:isSent', request.success)
      }
    }
    /**
     * 送信確認
     */
    const confirm = () => {
      if (!props.formRef) {
        // DOM未生成時は何もしない
        return
      }
      // バリデーションチェック
      props.formRef.validate((valid) => {
        if (!valid) {
          // チェックNG
          return false
        }
        addMessageQueue(MESSAGE_TYPE_CONFIRM, Message.codes.CONFIRM_SEND, async () => await send())
        return true
      })
    }

    return {
      confirm,
    }
  },
})
</script>
<style lang="scss" scoped>
.largest-btn-text {
  margin: 20px 80px;
  font-size: 40px;
}
</style>
